// @flow
export { default } from './UserTagView';



// WEBPACK FOOTER //
// ./src/components/user/UserTagView/index.js